import React from 'react'
import PropTypes from 'prop-types'

import PhotoAssetRenderer from './PhotoAsset'
import SlidesAssetRenderer from './SlidesAsset'
import UrlAssetRenderer from './UrlAsset'

const ASSET_RENDERER_MAPPING = {
  PhotoAsset: PhotoAssetRenderer,
  DocumentAsset: UrlAssetRenderer,
  SlidesAsset: SlidesAssetRenderer,
  UrlAsset: UrlAssetRenderer,
}

const Asset = (props) => {
  const Renderer = ASSET_RENDERER_MAPPING[props.asset.__typename]
  if (!Renderer) return null

  return (
    <Renderer
      {...props}
    />
  )
}

Asset.propTypes = {
  product: PropTypes.object.isRequired,
}

export default Asset
